var breakpoints = {
  s: 0,
  m: 767,
  l: 1025,
  xl: 1280,
  xxl: 1360
};
export default breakpoints;